appSocial.service('SocialConfigurationService', ['SocialAPIService', function (SocialAPIService) {
    class SocialConfigurationService {
        constructor() {
            /**
             * @type {SocialAPIService}
             */
            this.api = SocialAPIService;
            /**
             * @type {Map<string, any>}
             */
            this.configuration = new Map();
        }

        init() {
            return Promise.all([
                this.getConversionRates('conversionRates'),
                this.getMarkets('markets')
            ]);
        }

        /**
         * @param {string} key
         * @return {T}
         */
        get(key) {
            return this.configuration.get(key);
        }

        clear() {
            this.configuration.clear();
        }

        /**
         * @param {string} key
         * @return {void | Promise<void>}
         */
        getConversionRates(key) {
            return this.api.request.getConversionRates()
                .then((response) => this.configuration.set(key, response.conversion_rates))
                .catch(error => console.warn(`Failed to fetch configuration key [${key}]`));
        }

        /**
         * @param {string} key
         * @return {void | Promise<void>}
         */
        getMarkets(key) {
            return this.api.request.getMarkets()
                .then((response) => response.markets.map(item => item.name))
                .then((markets) => this.configuration.set(key, markets))
                .catch(error => console.warn(`Failed to fetch configuration key [${key}]`));
        }
    }

    return new SocialConfigurationService();
}]);
